<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        series: [
          {
            type: "tree",
            data: [
              {
                name: "Root",
                children: [
                  {
                    name: "Branch 1",
                    children: [{ name: "Leaf 1" }, { name: "Leaf 2" }]
                  },
                  {
                    name: "Branch 2",
                    children: [{ name: "Leaf 3" }, { name: "Leaf 4" }]
                  }
                ]
              }
            ],
            top: "1%",
            left: "7%",
            bottom: "1%",
            right: "20%",
            symbolSize: 7,
            label: {
              position: "left",
              verticalAlign: "middle",
              align: "right",
              fontSize: 9
            },
            leaves: {
              label: {
                position: "right",
                verticalAlign: "middle",
                align: "left"
              }
            },
            expandAndCollapse: true,
            initialTreeDepth: 1,
            animationDuration: 550,
            animationDurationUpdate: 750
          }
        ]
      }
    };
  }
};
</script>
